import { Modal, Button } from "antd";
import { useEffect, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DragItem from "./drag-item";
import { TableViewServices } from "../../../services/table-view";

interface ColumnConfig {
  column: string;
  label: string;
  isDisplay: number;
  sortOrder: number;
}

interface Props {
  open: boolean;
  onClose: () => void;
  configsTemplate: ColumnConfig[];
  configsValue: ColumnConfig[];
  onSave: (configs: ColumnConfig[]) => void;
}

const CustomizeModal: React.FC<Props> = ({ open, onClose, configsTemplate, configsValue, onSave }) => {
   const [columnConfigs, setColumnConfigs] = useState<ColumnConfig[]>([]); // Start empty
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // Merge configsValue into configsTemplate
    const merged = configsTemplate.map((templateItem) => {
      const valueItem = configsValue.find((v) => v.column === templateItem.column);
      return {
        ...templateItem,
        isDisplay: valueItem?.isDisplay ?? templateItem.isDisplay,
        sortOrder: valueItem?.sortOrder ?? templateItem.sortOrder,
      };
    });
      // Sort by sortOrder asc (null or undefined into last)
    merged.sort((a, b) => {
      if (a.sortOrder == null) return 1;
      if (b.sortOrder == null) return -1;
      return a.sortOrder - b.sortOrder;
    });

    setColumnConfigs(merged);
  }, [configsTemplate, configsValue]);

  const moveItem = (fromIndex: number, toIndex: number) => {
    const updated = [...columnConfigs];
    const [moved] = updated.splice(fromIndex, 1);
    updated.splice(toIndex, 0, moved);
    setColumnConfigs(updated.map((c, i) => ({ ...c, sortOrder: i + 1 })));
  };

  const toggleDisplay = (index: number) => {
    const updated = [...columnConfigs];
    updated[index].isDisplay = updated[index].isDisplay ? 0 : 1;
    setColumnConfigs(updated);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await TableViewServices.updateCustomView("suppliers", { columns: columnConfigs });
      onSave(columnConfigs);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Customise Suppliers Table view"
      open={open}
      onCancel={onClose}
      width={500}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={saving}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave} loading={saving}>
          Save
        </Button>,
      ]}
    >
      <DndProvider backend={HTML5Backend}>
        <div style={{ maxHeight: 460, overflowY: "auto", paddingRight: 8 }}>
          {columnConfigs.map((item, index) => (
            <DragItem
              key={item.column}
              id={item.column}
              index={index}
              label={item.label}
              checked={!!item.isDisplay}
              onToggle={() => toggleDisplay(index)}
              moveItem={moveItem}
            />
          ))}
        </div>
      </DndProvider>
    </Modal>
  );
};

export default CustomizeModal;
